import { render, staticRenderFns } from "./h5_header.vue?vue&type=template&id=2dca8e51&scoped=true"
import script from "./h5_header.vue?vue&type=script&lang=js"
export * from "./h5_header.vue?vue&type=script&lang=js"
import style0 from "./h5_header.vue?vue&type=style&index=0&id=2dca8e51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca8e51",
  null
  
)

export default component.exports